import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./login.module.css";
import axios from "axios";
import { URL } from "../AxiosUrlGlobal";
import Logo from '../../img/logo.png';
import { saveTeamAccess } from '../Helper/teamAccess';

function Login() {
  const [LoginLoading, setLoginLoading] = useState(false);
  const [mobile, setMobile] = useState();
  const [password, setPassword] = useState();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const handleLogin = async (event) => {
    setLoginLoading(true);
    axios
      .post(`${URL}login-team`, { mobile, password })
      .then((res) => {
        setLoginLoading(false);
        if (res.data.message === "Password not match") {
          toast.error("Password not match");
        }
        if (res.data.message === "User not found") {
          toast.error("User not found..");
        }

        if (res.data.refreshToken) {
          localStorage.setItem("token", res.data.refreshToken);
          localStorage.setItem("teamid", res.data.user._id);
          localStorage.setItem("Admin_Id", res.data.user.Admin_Id);
          // shared order components read the seller id from "id"
          localStorage.setItem("id", res.data.user.Admin_Id);
          localStorage.setItem("role", "2");
          localStorage.setItem("username", res.data.user.username || 'Team Member');
          saveTeamAccess(res.data.user.permissions, res.data.user.orderScope);
          navigate("/team-order");
        }
      })
      .catch((err) => toast.error(err.response.data));
  };

  return (
    <div className={styles["login-container"]}>
      <ToastContainer />
      {/* header section start */}
      <div className={styles["header-login"]}>
        <div className={styles["logo-main"]}>
          <a href="https://ecomtechbd.com">
            <img src={Logo} width={150} alt="Logo" />
          </a>
        </div>
        <div className={styles["login-main"]}>
          <ul>
            <li onClick={() => navigate('/login')}>USER LOGIN</li>
          </ul>
        </div>
        <div className={styles['mobile-menu-icon']} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        {mobileMenuOpen && (
          <div className={styles['mobile-menu']}>
            <div className={styles['mobile-menu-close']} onClick={() => setMobileMenuOpen(false)}>
              ×
            </div>
            <ul>
              <li onClick={() => { navigate('/login'); setMobileMenuOpen(false); }}>
                USER LOGIN
              </li>
            </ul>
          </div>
        )}
      </div>
      {/* header section end */}

      {/* login section start */}
      <div className={styles["login-signup-main"]}>
        <div className={styles["login-or-signup"]}>
          <div className={styles["login-inputs"]}>
            <h2 style={{
              textAlign: 'center',
              marginBottom: '2rem',
              color: '#667eea',
              fontSize: '1.5rem',
              fontWeight: '700'
            }}>
              Team Login
            </h2>
            <input
              type="number"
              placeholder="Mobile Number"
              onChange={(e) => setMobile(e.target.value)}
              value={mobile}
            />
            <input
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            <button className={styles["login-btn"]} onClick={() => handleLogin()}>
              {LoginLoading ? "Loading.." : "LOG IN"}
            </button>
          </div>
        </div>
      </div>
      {/* login section end */}

      {/* footer section start */}
      <div className={styles['footer-login']}>
        <p>© {new Date().getFullYear()} EcomTech BD. All rights reserved.</p>
      </div>
      {/* footer section end */}
    </div>
  );
}

export default Login;
